


















import { Component, Prop, Vue } from "vue-property-decorator";
import Vehicle from "../../models/vehicle";

@Component
export default class VehicleInformationCard extends Vue {
  @Prop() readonly vehicle!: Vehicle;

  get items(): any[] {
    if (!this.vehicle) {
      return [];
    }

    return [
      { title: "Digital Key", value: "Yes" },
      { title: "Engine", value: this.vehicle.engine.name },
      { title: "Fuel Type", value: this.vehicle.engine.fuelType },
      { title: "Horsepower", value: this.vehicle.horsepower() },
      {
        title: "No. of Cylinders",
        value: this.vehicle.engine.numberOfCylinders,
      },
      { title: "Telemetry Enabled", value: "No" },
      { title: "Transmission", value: this.vehicle.transmission.type },
      {
        title: "MPG",
        value: `${this.vehicle.mpg.city} city / ${this.vehicle.mpg.highway} highway`,
      },
    ];
  }
}
